export default __webpack_public_path__ + "static/media/SFG-GlyGen-NCBI-Nov-2020.f5d90401.pdf";